module.exports = __webpack_public_path__ + "pijl-rechts.png?36af6ee8a6850753798c307e08af2409";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pijl-rechts.png
// module id = 576
// module chunks = 0